/* eslint-disable jsx-a11y/media-has-caption */
import { alpha, Box, IconButton, useTheme } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import CallMissedIcon from '@src/resources/icons/CallMissedIcon';
import IconWrapper from '../Common/IconWrapper';
import LinearProgress from '../Common/LinearProgress';

const IncomingCallMissedView = () => {
  const theme = useTheme();
  // Note: disable action for now
  const displayIcon = false;

  return (
    <Box display="flex" style={{ height: 'inherit', width: 38 }}>
      <Box
        component="div"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position="relative"
        height="inherit"
        gridGap={6}
        pl={0.5}
        pr={1.5}
        width="100%"
        style={{
          background: alpha(theme.b2chatorange['600'], 0.25),
        }}
      >
        <IconButton size="small" style={{ padding: 4 }}>
          <IconWrapper fontSize={22} color={theme.b2chatorange['600']}>
            <CallMissedIcon />
          </IconWrapper>
        </IconButton>

        {displayIcon && (
          <IconButton size="small" style={{ padding: 4 }}>
            <IconWrapper fontSize={22} color={theme.b2chatorange['600']}>
              <MoreHorizIcon />
            </IconWrapper>
          </IconButton>
        )}
      </Box>

      <LinearProgress
        color={theme.b2chatorange['600']}
        orientation="vertical"
        value={100}
      />
    </Box>
  );
};

export default IncomingCallMissedView;
